import type { SVGProps } from "react";

export default function DataManagementIcon(
  props: Readonly<SVGProps<SVGSVGElement>>,
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 20 20"
      {...props}
    >
      <path
        d="M8.33341 16.6667C8.33341 17.5872 9.07958 18.3333 10.0001 18.3333C10.9206 18.3333 11.6667 17.5872 11.6667 16.6667C11.6667 15.7462 10.9206 15 10.0001 15C9.07958 15 8.33341 15.7462 8.33341 16.6667Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.9999 16.6667C14.9999 17.5872 15.7461 18.3333 16.6666 18.3333C17.5871 18.3333 18.3333 17.5872 18.3333 16.6667C18.3333 15.7462 17.5871 15 16.6666 15C15.7461 15 14.9999 15.7462 14.9999 16.6667Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.66667 16.6667C1.66667 17.5872 2.41283 18.3333 3.33333 18.3333C4.25383 18.3333 5 17.5872 5 16.6667C5 15.7462 4.25383 15 3.33333 15C2.41283 15 1.66667 15.7462 1.66667 16.6667Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.33341 3.33341C8.33341 4.25389 9.07958 5.00008 10.0001 5.00008C10.9206 5.00008 11.6667 4.25389 11.6667 3.33341C11.6667 2.41294 10.9206 1.66675 10.0001 1.66675C9.07958 1.66675 8.33341 2.41294 8.33341 3.33341Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 5L10 15"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6667 15.0001L16.6667 11.6667C16.6667 10.0001 15.8334 9.16675 14.1667 9.16675L5.83342 9.16675C4.16675 9.16675 3.33342 10.0001 3.33342 11.6667L3.33342 15.0001"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
